import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IRequestFailed, IMyProfileState } from "./types";

const initialState: IMyProfileState = {
  myProfile: {}, 
  updateUserProfile: {}
};

const slice = createSlice({
  name: "myProfile",
  initialState,
  reducers: {
    myProfile(state, action: PayloadAction) {
      state.myProfile.status = RequestStatus.RUNNING;
    },
    myProfileSuccess(state, action) {
      state.myProfile.status = RequestStatus.SUCCESS;
      state.myProfile.data = action.payload;
    },
    myProfileFailed(state, action: PayloadAction<IRequestFailed>) {
      state.myProfile.status = RequestStatus.ERROR;
      state.myProfile.error = action.payload;
    }, 
    updateUserProfile(state, action: PayloadAction<any>) {
      state.updateUserProfile.status = RequestStatus.RUNNING;
    },
    updateUserProfileSuccess(state, action) {
      state.updateUserProfile.status = RequestStatus.SUCCESS;
      state.updateUserProfile.data = action.payload;
    },
    updateUserProfileFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateUserProfile.status = RequestStatus.ERROR;
      state.updateUserProfile.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  myProfile,
  myProfileSuccess,
  myProfileFailed, 
  updateUserProfile, 
  updateUserProfileSuccess, 
  updateUserProfileFailed
} = slice.actions;
